import ArrowBackIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box } from "@mui/material";

import { CalendarNavigationIconButton } from "./CalendarNavigationIconButton";

interface Props {
  onPrevClick: () => void;
  onNextClick: () => void;
  previousLabel: string;
  nextLabel: string;
}

export function CalendarNavigationButton({ onPrevClick, onNextClick, previousLabel, nextLabel }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        border: "1px solid",
        borderColor: "action.active",
        backgroundColor: "#fff",
        borderRadius: 1,
        width: "60px",
      }}
    >
      <CalendarNavigationIconButton onClick={onPrevClick} ariaLabel={previousLabel}>
        <ArrowBackIcon sx={{ height: "16px", width: "16px" }} />
      </CalendarNavigationIconButton>

      <CalendarNavigationIconButton onClick={onNextClick} ariaLabel={nextLabel}>
        <ArrowForwardIcon sx={{ height: "16px", width: "16px" }} />
      </CalendarNavigationIconButton>
    </Box>
  );
}
